/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConversationLockRequest
 */
export interface ConversationLockRequest {
    /**
     * The date when the lock expires
     * @type {Date}
     * @memberof ConversationLockRequest
     */
    lockExpiresAt: Date;
    /**
     * The note for the lock
     * @type {string}
     * @memberof ConversationLockRequest
     */
    lockNote?: string | null;
    /**
     * The id of the USER/OWNER who locked the conversation
     * @type {string}
     * @memberof ConversationLockRequest
     */
    lockedBy?: string | null;
}

/**
 * Check if a given object implements the ConversationLockRequest interface.
 */
export function instanceOfConversationLockRequest(value: object): value is ConversationLockRequest {
    if (!('lockExpiresAt' in value) || value['lockExpiresAt'] === undefined) return false;
    return true;
}

export function ConversationLockRequestFromJSON(json: any): ConversationLockRequest {
    return ConversationLockRequestFromJSONTyped(json, false);
}

export function ConversationLockRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConversationLockRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'lockExpiresAt': (new Date(json['lock_expires_at'])),
        'lockNote': json['lock_note'] == null ? undefined : json['lock_note'],
        'lockedBy': json['locked_by'] == null ? undefined : json['locked_by'],
    };
}

export function ConversationLockRequestToJSON(json: any): ConversationLockRequest {
    return ConversationLockRequestToJSONTyped(json, false);
}

export function ConversationLockRequestToJSONTyped(value?: ConversationLockRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lock_expires_at': ((value['lockExpiresAt']).toISOString()),
        'lock_note': value['lockNote'],
        'locked_by': value['lockedBy'],
    };
}

